import { useContext, useEffect, useState } from "react";
import { VendorSettlementAnalyticsDto } from "../../../../dtos/catalogs/VendorSettlementAnalytics/VendorSettlementAnalyticsDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import VendorSettlementAnalyticsDetailMain from "./VendorSettlementAnalyticsDetailMain";

interface IProps {
  model: VendorSettlementAnalyticsDto | null;
  modelUpdatedEvent: (newModel: VendorSettlementAnalyticsDto) => void;
}

interface VendorSettlementAnalyticsModel {
  id: string;
  name?: string;
  uniqueCode?: string;
  contractId?: string;
  companyId?: string;
  vendorId?: string;
  createdDate?: Date;
  referenceType?: number;
  createdUserId?: string;
}

export const VendorSettlementAnalyticsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<VendorSettlementAnalyticsModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("uniqueCode", model.uniqueCode);
      setValue("contractId", model.contractId);
      setValue("companyId", model.companyId);
      setValue("vendorId", model.vendorId);
      setValue("createdDate", model.createdDate);
      setValue("referenceType", model.referenceType);
      setValue("createdUserId", model.createdUserId);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: VendorSettlementAnalyticsModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: VendorSettlementAnalyticsDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>
        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
            <VendorSettlementAnalyticsDetailMain/>
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
